module.exports = __webpack_public_path__ + "img/WebexToken_2.9a1cc8ac.png";